import React, { FunctionComponent } from "react";
import { Helmet } from "react-helmet";
import { Col, Container, Row } from "react-bootstrap";

import HeaderRow from "../common/HeaderRow";

export const Datenschutz: FunctionComponent = () => {
  return (
    <Container className={"h-100 py-5"}>
      <div>
        <Helmet>
          <title>Spielgruppe Online - Datenschutz</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <HeaderRow title={"Datenschutzerklärung"} headingLevel={1} />
        <Row className={"justify-content-center py-3"}>
          <Col className="privacy-content">
            <div className="mb-4">
              <p className="lead">
                Diese Datenschutzerklärung informiert Sie darüber, welche Personendaten wir erheben, wie wir sie
                bearbeiten und welche Rechte Ihnen nach dem schweizerischen Datenschutzgesetz (DSG) zustehen.
              </p>
            </div>

            <h2>1. Verantwortlicher</h2>
            <div className="mb-4">
              <p>
                Verantwortlich für die Bearbeitung Ihrer Personendaten im Sinne des schweizerischen Datenschutzgesetzes
                (DSG):
              </p>
              <address>
                <strong>webtie gmbh</strong>
                <br />
                Mauro Stehle, Sven Humbel
                <br />
                Im Feld 13c
                <br />
                5712 Beinwil am See
                <br />
                Schweiz
                <br />
                <br />
                E-Mail: <a href="https://www.webtie.ch/#contact">Kontakt aufnehmen</a>
                <br />
                Website:{" "}
                <a href="https://www.webtie.ch" target="_blank" rel="noopener">
                  www.webtie.ch
                </a>
              </address>
            </div>

            <h2>2. Zweck und Rechtsgrundsätze der Bearbeitung</h2>
            <div className="mb-4">
              <p>
                Wir bearbeiten Personendaten ausschliesslich für die in dieser Erklärung genannten Zwecke, namentlich
                zur Bereitstellung und dem Betrieb der Spielgruppen-Registrierungsplattform, zur Durchführung von
                Anmeldungen, zur Kommunikation mit Nutzenden und zur Erfüllung vertraglicher Leistungen.
              </p>
              <p>
                Die Bearbeitung erfolgt in der Regel auf Grundlage der Erforderlichkeit zur Erbringung der
                Dienstleistung oder auf Grundlage berechtigter Interessen (z. B. Betriebssicherheit,
                missbrauchsverhinderung), soweit nicht eine ausdrückliche Einwilligung vorliegt.
              </p>
            </div>

            <h3>2.1 Registrierungsdaten</h3>
            <div className="mb-3">
              <p>
                <strong>Erhobene Daten:</strong>
              </p>
              <ul>
                <li>E-Mail-Adresse (zur Benutzeranmeldung und -wiederherstellung)</li>
                <li>Benutzername und Profilangaben</li>
                <li>
                  Angaben aus Spielgruppen-Registrierungsformularen (Name des Kindes, Geburtsdatum, Kontaktdaten der
                  Erziehungsberechtigten, etc.)
                </li>
                <li>Verwaltungsdaten (z. B. Angebote, Limits, Rollen)</li>
              </ul>
              <p>
                <strong>Zweck:</strong> Bereitstellung der Registrierungsplattform und Verwaltung von Spielgruppen-
                Anmeldungen.
              </p>
            </div>

            <h3>2.2 E-Mail-Kommunikation</h3>
            <div className="mb-3">
              <p>
                <strong>Erhobene Daten:</strong>
              </p>
              <ul>
                <li>E-Mail-Adressen für Bestätigungen und Benachrichtigungen</li>
                <li>Personalisierbare E-Mail-Templates (Speicherung von Vorlagen-Inhalten)</li>
                <li>Versandstatistiken (z. B. Zustell- und Öffnungsstatus)</li>
              </ul>
              <p>
                <strong>Zweck:</strong> Versand von Anmeldebestätigungen, Systemmeldungen und wichtiger Mitteilungen an
                Nutzende.
              </p>
            </div>

            <h3>2.3 Technische Daten</h3>
            <div className="mb-4">
              <p>
                <strong>Automatisch erhobene Daten:</strong>
              </p>
              <ul>
                <li>IP-Adresse (anonymisiert / pseudonymisiert für Analytics)</li>
                <li>Browser- und Gerätedaten</li>
                <li>Zugriffszeitpunkte</li>
                <li>Besuchte Seiten (anonymisierte Auswertungen für Plausible Analytics und PostHog)</li>
              </ul>
              <p>
                <strong>Zweck:</strong> Betrieb, Sicherheit, Fehlerbehebung und anonymisierte Nutzungsstatistiken.
              </p>
            </div>

            <h2>3. Verwendete Dienste und Datenübermittlungen</h2>

            <h3>3.1 Firebase (Google Cloud)</h3>
            <div className="mb-3">
              <p>
                Wir nutzen Firebase (Google) für Benutzerauthentifizierung, Datenspeicherung (Firestore), Hosting und
                Cloud Functions.
              </p>
              <ul>
                <li>
                  <strong>Anbieter:</strong> Google LLC (bei Verarbeitung innerhalb der EU: Google Ireland Limited)
                </li>
                <li>
                  <strong>Datenstandort:</strong> EU-Regionen oder sonstige Server gemäss Firebase-Konfiguration
                </li>
                <li>
                  <strong>Übertragene Daten:</strong> Nutzerdaten, Registrierungen, Einstellungen
                </li>
                <li>
                  <strong>Zweck:</strong> Sichere Datenspeicherung und Authentifizierung
                </li>
              </ul>
              <p>
                Falls Daten in Drittstaaten (z. B. USA) übermittelt werden, erfolgt dies nur unter Anwendung geeigneter
                Garantien (z. B. Standardvertragsklauseln oder Data Privacy Framework), soweit dies notwendig ist.
              </p>
            </div>

            <h3>3.2 Brevo (E-Mail-Versand)</h3>
            <div className="mb-3">
              <p>
                Für den Versand von E-Mails verwenden wir Brevo (ehemals Sendinblue). Brevo verarbeitet E-Mail-Adressen
                und die Inhalte der Nachrichten ausschliesslich im Auftrag und gemäss unseren Weisungen.
              </p>
              <ul>
                <li>
                  <strong>Anbieter:</strong> Brevo / Sendinblue
                </li>
                <li>
                  <strong>Datenstandort:</strong> EU (Deutschland/Frankreich oder entsprechende Rechenzentren)
                </li>
                <li>
                  <strong>Übertragene Daten:</strong> E-Mail-Adressen, E-Mail-Inhalte, Versandstatistiken
                </li>
                <li>
                  <strong>Zweck:</strong> Zuverlässiger E-Mail-Versand
                </li>
              </ul>
            </div>

            <h3>3.3 Plausible Analytics</h3>
            <div className="mb-4">
              <p>
                Wir setzen Plausible Analytics ein, eine datenschutzfreundliche, cookieless Web-Analytik-Lösung. Die
                gesammelten Daten sind anonymisiert und erlauben keine Identifikation einzelner Personen.
              </p>
              <ul>
                <li>
                  <strong>Anbieter:</strong> Plausible Insights OÜ
                </li>
                <li>
                  <strong>Datenstandort:</strong> EU
                </li>
                <li>
                  <strong>Besonderheit:</strong> Keine Cookies, vollständig anonymisierte Auswertung
                </li>
                <li>
                  <strong>Zweck:</strong> Verbesserung der Nutzererfahrung und statistische Auswertung
                </li>
              </ul>
            </div>

            <h3>3.4 PostHog Analytics</h3>
            <div className="mb-4">
              <p>
                Zusätzlich verwenden wir PostHog zur Analyse der Nutzung unserer Plattform und zur Verbesserung der
                Benutzerfreundlichkeit. PostHog wird ausschliesslich mit EU-basierten Servern betrieben, und die Daten
                werden anonymisiert, soweit möglich.
              </p>
              <ul>
                <li>
                  <strong>Anbieter:</strong> PostHog Inc.
                </li>
                <li>
                  <strong>Datenstandort:</strong> EU
                </li>
                <li>
                  <strong>Erhobene Daten:</strong> Nutzungsereignisse (z. B. Klicks, Navigationspfade), anonyme
                  Sitzungsinformationen, technische Metadaten (Browsertyp, Betriebssystem)
                </li>
                <li>
                  <strong>Zweck:</strong> Verbesserung der Benutzererfahrung, Produktentwicklung und Fehlermonitoring
                </li>
              </ul>
              <p>
                Eine Identifikation einzelner Nutzenden findet nicht statt; personenbezogene Daten werden nur erfasst,
                sofern diese ausdrücklich und freiwillig angegeben werden.
              </p>
            </div>

            <h2>4. Weitergabe und Übermittlung ins Ausland</h2>
            <div className="mb-4">
              <p>
                Eine Weitergabe von Personendaten an Dritte erfolgt nur, soweit dies zur Erbringung der Dienste
                erforderlich ist (z. B. an Hosting- oder E-Mail-Dienstleister), oder wenn Sie zuvor eingewilligt haben.
              </p>
              <p>
                Datenübermittlungen in Staaten ausserhalb der Schweiz und der EU/EWR erfolgen nur, wenn der Empfänger
                ein angemessenes Datenschutzniveau bietet oder wir angemessene Schutzmassnahmen (z. B.
                Standardvertragsklauseln) getroffen haben.
              </p>
            </div>

            <h2>5. Ihre Rechte (nach DSG)</h2>
            <div className="mb-4">
              <p>Sie haben nach dem schweizerischen Datenschutzgesetz insbesondere das Recht auf:</p>
              <ul>
                <li>Auskunft über die Sie betreffenden Personendaten,</li>
                <li>Berichtigung unrichtiger Daten,</li>
                <li>Löschung oder Einschränkung der Bearbeitung,</li>
                <li>Herausgabe / Datenportabilität in einem strukturierten, gängigen Format.</li>
              </ul>
              <p>
                Zur Ausübung Ihrer Rechte oder bei Fragen kontaktieren Sie uns bitte unter:
                <a href="https://www.webtie.ch/#contact"> Kontakt aufnehmen</a>.
              </p>
            </div>

            <h2>6. Datensicherheit</h2>
            <div className="mb-4">
              <p>
                Wir treffen angemessene technische und organisatorische Massnahmen, um Personendaten gegen Verlust,
                unbefugten Zugriff, Missbrauch und unbefugte Veränderung zu schützen. Dazu gehören unter anderem:
              </p>
              <ul>
                <li>Verschlüsselte Datenübertragung (SSL/TLS)</li>
                <li>Sichere Authentifizierung und Zugriffssteuerung (Firebase Auth)</li>
                <li>Regelmässige Sicherheitsupdates und Backup-Verfahren</li>
                <li>Rollenbasierte Zugriffsbeschränkungen für Administratoren</li>
              </ul>
            </div>

            <h2>7. Speicherdauer</h2>
            <div className="mb-4">
              <p>
                Wir speichern Personendaten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist oder
                gesetzliche Aufbewahrungspflichten bestehen.
              </p>
              <ul>
                <li>
                  <strong>Benutzerkonto:</strong> Bis zur Löschung des Kontos durch die Nutzenden.
                </li>
                <li>
                  <strong>Registrierungsdaten:</strong> Solange der Kontoinhaber die Daten nicht löscht oder das Konto
                  besteht.
                </li>
                <li>
                  <strong>E-Mail-Logs:</strong> 6 Monate (zur Fehleranalyse und Revisionszwecken).
                </li>
                <li>
                  <strong>Analytics-Daten:</strong> 24 Monate (anonymisiert, aggregiert).
                </li>
              </ul>
            </div>

            <h2>8. Cookies und Tracking</h2>
            <div className="mb-4">
              <p>
                Unsere Website verwendet nur technisch notwendige Funktionalitäten für den Betrieb (z. B. Session-
                Management für Firebase Auth). Plausible Analytics und PostHog arbeiten cookieless und anonymisiert. Es
                werden keine Marketing-Cookies oder verhaltensbezogenes Tracking eingesetzt.
              </p>
            </div>

            <h2>9. Kinder und Jugendliche</h2>
            <div className="mb-4">
              <p>
                Die Plattform richtet sich an Spielgruppen und verarbeitet deshalb Daten von Kindern. Die Registrierung
                darf nur durch Erziehungsberechtigte erfolgen. Erziehungsberechtigte versichern, dass sie die
                erforderliche Zustimmung für die Angabe der Daten ihres Kindes erteilen.
              </p>
            </div>

            <h2>10. Änderungen dieser Datenschutzerklärung</h2>
            <div className="mb-4">
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen. Massgeblich ist die jeweils auf der Website
                veröffentlichte Fassung.
              </p>
              <p>
                <strong>Stand:</strong> 20. Oktober 2025
              </p>
            </div>

            <h2>11. Kontakt & Beschwerden</h2>
            <div className="mb-4">
              <p>
                Bei Fragen zur Bearbeitung Ihrer Personendaten oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an
                uns: <a href="https://www.webtie.ch/#contact">Kontakt aufnehmen</a>.
              </p>
              <p>
                Sie haben ferner das Recht, sich beim Eidgenössischen Datenschutz- und Öffentlichkeitsbeauftragten
                (EDÖB) zu beschweren, wenn Sie eine Verletzung des Datenschutzes vermuten.
              </p>
            </div>

            <br />
            <p>
              Mauro Stehle, Sven Humbel
              <br />
              Im Feld 13c
              <br />
              5712 Beinwil am See
            </p>
            <p>
              Kontakt aufnehmen: <a href="https://www.webtie.ch/#contact">webtie.ch/#contact</a>
              <br />
              Website: https://portal.spielgruppe.online/
            </p>

            <h2>Allgemeiner Hinweis</h2>
            <p>
              Wir sind bestrebt, Ihre Personendaten vertraulich und gemäss den geltenden gesetzlichen Bestimmungen zu
              behandeln. Trotz aller Sorgfalt kann eine lückenlose Sicherheit der Datenübertragung im Internet nicht
              garantiert werden.
            </p>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Datenschutz;
